(() => {
  'use strict';
  const selector = '[data-native-accelerated-wallets]';
  const eligible = (state, config, context, api, helper) => {
    try {
      if (context?.hostname !== 'polygons-1.myshopify.com' || context.checkoutDeliveryPreview !== true
        || context.countryCode !== 'US' || context.currencyCode !== 'USD' || config?.catalogMode !== true
        || !state?.cart?.item_count || !state.plan || state.pendingOperation
        || state.plan.countryCode !== 'US' || state.plan.currencyCode !== 'USD'
        || state.plan.showSplitChoice !== false || state.plan.totalQuantity !== state.cart.item_count
        || state.cart.attributes?._polygons_checkout_delivery !== 'preview-v1') return false;
      // Cart wallets include methods that cannot change delivery timing. Mixed
      // orders keep standard checkout until the Shop Pay selector is verified.
      if (state.plan.backorderQuantity > 0 && state.plan.fullBackorder !== true) return false;
      api.validateConfig(config, context.hostname);
      return api.ajaxChanges(state.cart, state.plan).length === 0
        && Boolean(helper.confirmedPrice(state.cart, state.plan, config, context));
    } catch { return false; }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = {eligible};
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const records = new Map();
  const hide = root => {
    root.hidden = true; root.inert = true; root.dataset.nativeWalletReady = 'false';
    records.delete(root);
  };
  const update = (container, {state, busy = false} = {}) => {
    const roots = container?.matches?.(selector) ? [container] : [...(container?.querySelectorAll?.(selector) || [])];
    const {PolygonsNativeCommerceConfig: config, PolygonsNativeContext: context, PolygonsNativeCommerce: api, PolygonsNativeCart: helper} = window;
    for (const root of roots) {
      hide(root);
      if (busy || !eligible(state, config, context, api, helper)) continue;
      records.set(root, {state, config, context, api, helper, fingerprint: helper.stateOf(state.cart)});
      root.dataset.nativeWalletReady = 'true'; root.hidden = false; root.inert = false;
    }
  };
  const allow = candidate => {
    const root = candidate?.matches?.(selector) ? candidate : candidate?.closest?.(selector);
    const record = records.get(root);
    if (!root || root.hidden || root.inert || !record) return false;
    if (!eligible(record.state, record.config, record.context, record.api, record.helper)
      || record.fingerprint !== record.helper.stateOf(record.state.cart)) { hide(root); return false; }
    return true;
  };
  const invalidate = () => { for (const root of records.keys()) hide(root); };
  document.addEventListener('click', event => {
    const root = event.target.closest?.(selector);
    if (root && !allow(root)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  window.addEventListener('pageshow', event => { if (event.persisted) invalidate(); });
  window.addEventListener('storage', event => { if (event.key === 'polygons-native-operation-v1') invalidate(); });
  window.PolygonsNativeWallets = {update, allow, invalidate};
})();
